import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const messageReducer = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      return { message: action.payload };
    },
    clearMessage: () => {
      return { message: "" };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMessage, clearMessage } = messageReducer.actions;

export default messageReducer.reducer;
